<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
    <path fill="currentColor" fill-rule="evenodd" d="M28.4 3H3.6v21.4h24.8V3zM1.6 1v25.4h28.8V1H1.6z" clip-rule="evenodd" />
    <path fill="currentColor" fill-rule="evenodd" d="M15 25.524V1.932h2v23.592h-2z" clip-rule="evenodd" />
    <path fill="currentColor" fill-rule="evenodd" d="M26.8 26.4H5.2v2.4h21.6v-2.4zm-23.6-2v6.4h25.6v-6.4H3.2z" clip-rule="evenodd" />
    <path fill="currentColor" d="M22 12.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM13 12.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
  </svg>
</template>
